// 目录
export const MENU_CHANGE = 'MENU_CHANGE'
export const MENU_CLICK = 'MENU_CLICK'
export const SPLICE_TABSLIST = 'SPLICE_TABSLIST'
export const CLEAR_MENU = 'CLEAR_MENU'
export const ADD_COUNT = 'ADD_COUNT'
export const CHANGE_ACTIVE_URL = 'CHANGE_ACTIVE_URL'
export const CHANGE_ALL_URL = 'CHANGE_ALL_URL'
//登录
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
// 修改密码
export const CHANGE_PWD = 'CHANGE_PWD'
// 设置用户
export const SET_USER = 'SET_USER'
// 获取权限树
export const SET_PERM = 'SET_PERM'
//当前责任人
export const SET_RESPONSIBLE = 'SET_RESPONSIBLE'
//权限树设置
export const SET_PERMMAP = 'SET_PERMMAP'
// 设置字典
export const SET_DICT = 'SET_DICT'
export const GET_VCODE = 'GET_VCODE'
//获取列表
export const GET_LIST = 'GET_LIST';
export const SET_LIST = 'SET_LIST';
export const RESET_CASEPOOL = 'RESET_CASEPOOL';
//获取人员列表
export const GET_MEMBER = 'GET_MEMBER';
export const SET_MEMBER = 'SET_MEMBER';

// 更新当前页面数据
export const CURRENTFIELD = 'CURRENTFIELD';
// 切换tab时更新前一个页面form数据
export const INITFORM = 'INITFORM';
// 案件状态
export const GET_STATUS_DICT = 'GET_STATUS_DICT'
export const SET_STATUS_DICT = 'SET_STATUS_DICT'

// 结案登记获取关闭原因
export const GET_CLOSED_REASON = 'GET_CLOSED_REASON';
export const SET_CLOSED_REASON = 'SET_CLOSED_REASON'
//结案登记
export const GET_CLOSINGREGTS = 'GET_CLOSINGREGTS';

export const GET_HANDLE_BATCH = 'GET_HANDLE_BATCH';

// 获取详情信息
export const GET_DETAIL = 'GET_DETAIL'
export const SET_DETAIL = 'SET_DETAIL'
export const RESET_DETAIL = 'RESET_DETAIL'

// 额外调解信息
export const SET_EXTRA_MEDIATION = 'SET_EXTRA_MEDIATION'
export const POST_EXTRA_MEDIATION = 'POST_EXTRA_MEDIATION'

// 详情操作
export const POST_DETAIL_SUBMIT = 'POST_DETAIL_SUBMIT'
//自动协查找人
export const POST_AUTOMATIC_SUBMIT = 'POST_AUTOMATIC_SUBMIT'

//回款登记
export const POST_PAYMENT_SUBMIT = 'POST_PAYMENT_SUBMIT'
export const POST_PAYMENT_SUBMITUPDATE = 'POST_PAYMENT_SUBMITUPDATE'
// 详情全局变量
export const GLOBAL_VARIABLE = 'GLOBAL_VARIABLE'
//打印
export const GET_PDFCONVERSION = 'GET_PDFCONVERSION'
//文书审核
export const GET_CHECKRES = 'GET_CHECKRES';
//电子卷宗删除
export const GET_DELETEFILE = 'GET_DELETEFILE';
//电子卷宗批量下载
export const DOWNLOAD_ELE = 'DOWNLOAD_ELE';

// 开始 庭审/在线调解
export const START_MEETING = 'START_MEETING'
// 协查找人 获取
export const GET_LOST_PHONE = 'GET_LOST_PHONE'
// 申请协商还款
export const SUBMIT_NEGREPAY = 'SUBMIT_NEGREPAY'
// 调解登记内容
export const SET_REGISTRATION = 'SET_REGISTRATION'

// 获取电话号
export const GET_PHONENUMBER = 'GET_PHONENUMBER';

//获取调解时间
export const MEDIATIONTIME = 'MEDIATIONTIME';

//调解登记新增
export const GET_MEDIATIONREGISTER = 'GET_MEDIATIONREGISTER';
//调解登记修改
export const GET_MEDIATIONREGISTERUPDATE = 'GET_MEDIATIONREGISTERUPDATE';
// 拨打电话
export const CALL_DEFENDANT = 'CALL_DEFENDANT';
//发送闪信
export const SEND_FLASHLETTER = 'SEND_FLASHLETTER';
// 发送账密短信
export const POST_SENDMSG = 'POST_SENDMSG';

// 获取调解方案
export const GET_MEDIATION_DOC = 'GET_MEDIATION_DOC';
// 推送调解方案
export const POST_MEDIATION_DOC = 'POST_MEDIATION_DOC';
// 获取调解场次
export const GET_MEDIATION_SESSION = 'GET_MEDIATION_SESSION';
// 批量开启在线调解
export const POST_MEDIATION_BATCH = 'POST_MEDIATION_BATCH';
//电子卷宗上传
export const GET_DZJZUPLOAD = 'GET_DZJZUPLOAD';
// 获取签名
export const GET_SIGNATURE = 'GET_SIGNATURE';
export const GET_BASEURL = 'GET_BASEURL';
export const SET_BASEURL = 'SET_BASEURL';
export const POST_CANVAS = 'POST_CANVAS'

//获取电话平台类型
export const GET_CALLTYPE = 'GET_CALLTYPE'
export const SET_CALLTYPE = 'SET_CALLTYPE'

//获取协查找人平台来源
export const GET_LOSTPROVIDERTYPEDICT = 'GET_LOSTPROVIDERTYPEDICT'
export const SET_LOSTPROVIDERTYPEDICT = 'SET_LOSTPROVIDERTYPEDICT'
export const SET_LOSTPROVIDERTYPEDICTCASEPOOL = 'SET_LOSTPROVIDERTYPEDICTCASEPOOL'
